import React, {FC} from 'react';
import {StyleProp, Text, View, ViewStyle} from 'react-native';
import {formsStyles} from '../formStyles';

interface TitleLabelProps {
  label?: string | React.ReactNode;
  required?: boolean;
  style?: StyleProp<ViewStyle>;
}
export const TitleLabel: FC<TitleLabelProps> = props => {
  const {label = '', required = false, style} = props;
  return (
    <View style={style}>
      {label ? (
        <Text style={[formsStyles.labelStyle]}>
          {label} {required ? '*' : ''} :
        </Text>
      ) : null}
    </View>
  );
};
